import { IYxInputPropTypes } from "./basePropType";
import PropType from "prop-types";
import { IYxrequest } from "../../../utils/propType";
import { l } from "../../../config/language";
import Config from "../../../config";

export const ICascaderPropTypes = {
  ...IYxInputPropTypes,

  //请求结果的数据路径,默认data
  dataPath: PropType.string,

  // 是否开启根据文本内容自动伸缩宽度,默认false
  isAutoWidth: PropType.bool,

  //级联深度
  depth: PropType.number,

  //级联请求参数
  requestParam: IYxrequest,
  request: IYxrequest,

  //当 request不为空的时候,请求回调 Function
  requestCallback: PropType.func,

  //默认值
  defaultValue: PropType.array,

  //级联数据，优先级会比请求数据高
  data: PropType.arrayOf(PropType.object),

  //设置为true的时候，会将请求的第一个值作为默认值
  requestDefaultValue: PropType.bool,

  version: PropType.string,
};

export const cascaderDefaultProps = () => ({
  version: null,
  styleParam: {
    width: "sm", //宽度  xxs,xs,sm,md,lg,xl
    size: "default", //大小
    type: "default", //类型
  },
  // 默认props
  data: [], // 级联数据
  value: [], // 默认选中
  depth: null, // 级联深度
  request: null, // 级联请求参数
  defaultValue: [], // 默认选中值
  isAutoWidth: false, // 是否开启自适应
  requestCallback: null, // 级联请求数据回调
  dataPath: Config.input.cascader.dataPath, // 请求数据的数据路径
  inputParam: {
    options: [],
    placeholder: l("YxCascader.ipt"),
    changeOnSelect: false,
  },
  rules: {},
  children: "",
  formItemParam: {},
  change: function () {},
});



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IpropType/cascaderPropType.js